import axios from 'axios'

let Api = () => {
  return axios.create({
    baseURL: '/',
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}

export default {
  getImages() {
    return Api().get('/spot_the_not.json')
  }
}